import { useCurrentTenant } from "@qpr/client-library/dist/esm";
import useTopElement from "backend/hooks/model/useTopElement";
import { getTranslatedAttribute } from "qpr-base//tplutils/utils";
import useParents from "qpr-base/apihooks/useParents";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import useLink from "qpr-base/hooks/useCreateLink";
import BreadcrumbDesign from "qpr-base/ui/BreadcrumbDesign";
import Loader from "qpr-base/ui/components/Loader";
import React from "react";
import typeToView from "routing/typetoview";

const Breadcrumb = () => {
  const ctx = useAppContext();
  const tenant = useCurrentTenant();
  const shouldHideForReporting =
    ctx.page === "reporttemplates" ||
    ctx.page === "configurablereports" ||
    ctx.page === "mytasks" ||
    ctx.page === "taskworkflow" ||
    ctx.page === "workflowinput" ||
    ctx.page === "delegation" ||
    ctx.page === "completedtasks";
  const { data: topElement, isLoading: topElementLoading } = useTopElement(
    shouldHideForReporting ? "" : "L0",
    "id,name,typename"
  );
  const parents = useParents(shouldHideForReporting ? "" : ctx.elementId || "");
  const link = useLink();
  // Home icon removed - now shown in app bar for all users

  if (shouldHideForReporting) return <></>;

  if (!topElement) return <></>;
  if (!parents || topElementLoading) {
    return <Loader />;
  }

  if (
    !parents ||
    !ctx.elementId ||
    parents.length === 0 ||
    ctx.page === "landingpage"
  ) {
    return (
      <BreadcrumbDesign
        items={[
          {
            title: getTranslatedAttribute(topElement, "Name", ctx.language),
            url: `/${tenant.symbol}/${ctx.modelId}/strategymap/${topElement.id}`,
          },
        ]}
      />
    );
  }

  return (
    <BreadcrumbDesign
      items={[
        ...parents
          .filter((p) => typeToView(p.typename))
          .map((p) => {
            return {
              title: getTranslatedAttribute(p, "Name", ctx.language),
              url: link({ meaId: p.id, page: typeToView(p.typename) }),
            };
          }),
      ]}
    />
  );
};

export default Breadcrumb;
